/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class DataQualityGovernanceAPI extends ApiClient {
  constructor() {
    super('data_quality_governance', { accountScoped: true });
  }

  get issuesUrl() {
    return this.url.replace(
      /\/data_quality_governance$/,
      '/data_quality_issues'
    );
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  transitionIssue(id, action, payload = {}) {
    return axios.post(
      resourcePath(this.issuesUrl, encodeURIComponent(id), action),
      payload,
      requestConfig()
    );
  }

  rejectDuplicateCandidate(payload = {}) {
    return axios.post(
      resourcePath(this.url, 'duplicate_candidates', 'reject'),
      payload,
      requestConfig()
    );
  }

  planMerge(payload = {}) {
    return axios.post(
      resourcePath(this.url, 'merge_operations', 'plan'),
      payload,
      requestConfig()
    );
  }

  applyMerge(payload = {}) {
    return axios.post(
      resourcePath(this.url, 'merge_operations', 'apply'),
      payload,
      requestConfig()
    );
  }

  revertMerge(payload = {}) {
    return axios.post(
      resourcePath(this.url, 'merge_operations', 'revert'),
      payload,
      requestConfig()
    );
  }

  reviewFraudSignal(payload = {}) {
    return axios.post(
      resourcePath(this.url, 'fraud_signals', 'review'),
      payload,
      requestConfig()
    );
  }

  quarantineFraudSignal(payload = {}) {
    return axios.post(
      resourcePath(this.url, 'fraud_signals', 'quarantine'),
      payload,
      requestConfig()
    );
  }

  releaseFraudSignal(payload = {}) {
    return axios.post(
      resourcePath(this.url, 'fraud_signals', 'release'),
      payload,
      requestConfig()
    );
  }
}

export default new DataQualityGovernanceAPI();
